export default {
  expandChat: {evid: 523},
  sendMessage: {evid: 524},
  technicalError: {evid: 525},
  firebaseConnectionOn: {evid: 528},
  firebaseConnectionOff: {evid: 529},
  realtimeActivity: {evid: 530}
};



// WEBPACK FOOTER //
// ./chat-app/biLogger/events.js